<template>
  <!-- <img src="@/assets/img/theme/2021/index-logo.png" /> -->
  <!-- <img src="@/assets/img/icon/newLogo.png" /> -->
  <div class="tg-icon-logo" :class="site"></div>
</template>

<script>
export default {
  name: "TgLogo",
  props: {
    site: String
  }
};
</script>